import { render, staticRenderFns } from "./MemberBalance.vue?vue&type=template&id=510cc544&scoped=true&"
import script from "./MemberBalance.vue?vue&type=script&lang=js&"
export * from "./MemberBalance.vue?vue&type=script&lang=js&"
import style0 from "./MemberBalance.vue?vue&type=style&index=0&id=510cc544&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510cc544",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})
